import React, { useEffect, useState } from "react";

import ToolBlock from "../../../AdministrativeProcedures/commonComponents/ToolBlock/ToolBlock";
import SearchTable from "../../../GeneralComponents/SearchTable/SearchTable";
import { ProgressBar } from "react-loader-spinner";
import Cookies from "js-cookie";

import { Modal } from "react-bootstrap";

import { fetchWithToken } from "../../../../interceptors/fetchInterceptor";

import {
  API_GET_PROTOCOLS_FOR_PEOPLE_KNOWELEDGE_TEST_RECORD,
  MAIN_URL,
  PORT_FOR_TRAINING,
} from "../../../../constants/constants";

import styles from "./modalWindowShowProtocolHistory.module.css";

function ModalWindowShowProtocolHistory({
  show,
  setShowWindow,
  modalTitle,
  inputs,
  headersTable,
  id,
  handlerShowNotificationWindow,
  viewAccess = true,
  editAccess = true,
  additionalAccess = {},
}) {
  const [data, setData] = useState({
    protocols: [],
  });
  const [propsForButtons, setPropsForButtons] = useState({
    disabledButtonView: false,
    disabledButtonEdit: true,
  });
  const [isLoading, setIsLoading] = useState(true);
  const [tableElementId, setTableElementId] = useState(null);

  const userId = Number(Cookies.get("userId"));

  useEffect(() => {
    const selectedElement = data.protocols.find((el) => String(el.id) === tableElementId);
    if (selectedElement) {
      switch (true) {
        case selectedElement?.examType === 2 && selectedElement?.passed === "-": {
          setPropsForButtons({
            disabledButtonView: true,
            disabledButtonEdit: selectedElement.inspector === userId ? false : true,
          });
          break;
        }
        default: {
          setPropsForButtons({
            disabledButtonView: true,
            disabledButtonEdit: true,
          });
        }
      }
    }
  }, [tableElementId]);

  useEffect(() => {
    async function fetchData() {
      const response = await fetchWithToken(
        MAIN_URL + PORT_FOR_TRAINING + API_GET_PROTOCOLS_FOR_PEOPLE_KNOWELEDGE_TEST_RECORD + String(id),
      );
      if (response.status !== 200) {
        const responseData = await response.text();
        handlerShowNotificationWindow(responseData);
        setShowWindow(!show);
        setIsLoading(false);
      } else {
        const data = await response.json();
        setData(data);
        setIsLoading(false);
      }
    }
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className={"d-flex flex-column justify-content-center align-items-center"}>
        <ProgressBar
          height="80"
          width="80"
          ariaLabel="progress-bar-loading"
          wrapperStyle={{}}
          wrapperClass="progress-bar-wrapper"
          borderColor="#D2AF8E"
          barColor="#BC8653"
        />
      </div>
    );
  }
  return (
    <Modal
      show={show}
      onHide={() => setShowWindow(!show)}
      aria-labelledby="contained-modal-title-vcenter"
      centered
      fullscreen="lg-down"
      size="xl">
      <Modal.Header
        closeButton
        className={styles["form-header"]}>
        <Modal.Title className={styles["form-title"]}>{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body className={styles["form-body"]}>
        {Object.values(inputs).map((el) => {
          return (
            <div className={`${styles["text-block"]} ${styles?.[`box-${el.key}`]}`}>
              <p className={styles["option-label"]}>{el.value}</p>
              <p className={styles["option-value"]}>
                {el.type === "date" && data[el.key]
                  ? data[el.key].split("-").reverse().join(".")
                  : data[el.key] || "—"}
              </p>
            </div>
            // <Form>
            //   <Form.Group className={"mb-2"}>
            //     <Form.Label>{el.value}</Form.Label>
            //     <Form.Control
            //       style={(() => {
            //         const copyInputStyle = { ...inputStyle };
            //         copyInputStyle.width = `${data[el.key]?.length * 11}px`;
            //         return copyInputStyle;
            //       })()}
            //       value={data[el.key]}
            //       disabled={el.disabled}
            //       readOnly={el.readOnly}
            //       type={el.type}
            //     />
            //   </Form.Group>
            // </Form>
          );
        })}
        <ToolBlock
          id={data.protocols.find((el) => String(el.id) === tableElementId)?.protNum}
          propsForButtons={propsForButtons}
          viewAccess={viewAccess}
          editAccess={editAccess}
          additionalAccess={additionalAccess}
        />
        <SearchTable
          headerColumns={headersTable}
          dataFromState={data.protocols}
          setId={setTableElementId}
        />
      </Modal.Body>
    </Modal>
  );
}

export default ModalWindowShowProtocolHistory;
